<template>
  <div class="navBox">
      <div class="name">
          <p class="">管理系统</p>
      </div>
      <div class="navList">
        <div class="navItem" v-for="item in navList" v-bind:key="item.id">
          <div class="item" :class="navID==item.id?'select':''" @click="navSub(item)">
            <i class="icon" :class="'icon'+item.id"></i>
            <p>{{item.label}}</p>
          </div>
          <div class="children" v-if="item.showType">
            <div class="item" v-for="ele in item.children" v-bind:key="ele.id" :class="ele.id==childrenID?'select':''" @click='childrenSub(ele)'>
              <p>{{ele.label}}</p>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  export default {
      name: 'navBox',
      data() {
        return {
          // navList: [
          //   {
          //     id:1,
          //     label: 'AI演讲教练',
          //     children: [{
          //       id:'1-1',
          //       label: '每日一词',
          //       url:'/word'
          //     },{
          //       id:'1-2',
          //       label: '演讲管理',
          //       url:'/speech'
          //     },{
          //       id:'1-3',
          //       label: '类型管理',
          //       url:'/type'
          //     },{
          //       id:'1-4',
          //       label: '会员管理',
          //       url:'/vip'
          //     }]
          //   }, 
          // ],
          navList: [
            {
              id:1,
              label: '每日一词',
              url:'/word'
            }, 
            {
              id:13,
              label: '评估管理',
              url:'/evaluate'
            }, 
            {
              id:2,
              label: '演讲管理',
              children: [{
                id:'2-1',
                label: '演讲管理',
                url:'/speech'
              },{
                id:'2-2',
                label: '演讲类型管理',
                url:'/type'
              }]
            }, 
            {
              id:3,
              label: '练习管理',
              children: [{
                id:'3-1',
                label: '练习管理',
                url:'/exam'
              },{
                id:'3-2',
                label: '练习类型管理',
                url:'/examType'
              }]
            }, 
            {
              id:4,
              label: '会员管理',
              url:'/vip'
            }, 
            {
              id:5,
              label: '数字人管理',
              url:'/user'
            }, 
            {
              id:8,
              label: '加量包',
              url:'/pkgList'
            }, 
            {
              id:9,
              label: '词库管理',
              url:'/wordIndex'
            },
            {
              id:16,
              label: 'AI提示词管理',
              url:'/promptIndex'
            }, 
            {
              id:17,
              label: '课程管理',
              url:'/coursetIndex'
            }, 
            {
              id:14,
              label: '徽章管理',
              url:'/badge'
            }, 
            {
              id:15,
              label: '等级管理',
              url:'/level'
            }, 
            {
              id:10,
              label: '打卡管理',
              url:'/clockIndex'
            }, 
            {
              id:11,
              label: '提现列表',
              url:'/withdraw'
            },
            {
              id:6,
              label: '用户反馈',
              url:'/feedback'
            }, 
            {
              id:7,
              label: '用户管理',
              children: [{
                id:'7-1',
                label: '用户信息',
                url:'/info'
              },{
                id:'7-2',
                label: '订单管理',
                url:'/order'
              }]
            },
            {
              id:12,
              label: '核销码',
              url:'/codeList'
            }, 
          ],
          navID:'',
          childrenID:'',
          userData:'',
          url:''
        };
      },
      props: {
        title: String,
        visible: {
          type: Boolean,
          default: false
        },
        id: String,
        cid: String,
      },
      mounted() {
        // this.getUser();
        var that = this;
        this.navID = this.id;
        this.childrenID = this.cid;
        var list = this.navList;
        list.forEach(function(item,index){
          if(that.navID == item.id&&!item.children){
            document.title = item.label
          };
          if(item.children){
            item.children.forEach(function(ele,num){
              if(ele.id == that.childrenID){
                item.showType = true;
                document.title = ele.label;
              }
            })
          };
        });
        this.$forceUpdate();
        var url = '';
        if(window.location.origin == 'https://web.speechcoach.cn'){
          url = 'https://app.speechcoach.cn/'
        } else {
          url = 'https://lite.speechcoach.cn/'
        };
        this.url = url;
      },
      methods: {
        navSub(e){
          var that = this;
          if(e.children){
            e.showType = !e.showType;
            this.childrenID = e.id;
          };
          this.navID = e.id;
          this.$forceUpdate();
          if(e.url){
            this.$router.push(e.url);
          }
        },

        childrenSub(e){
          if(e.url){
            this.$router.push(e.url);
          }else {
            this.$message('暂无')
          }
        },

        getUser(){
          var that = this;
          var data = localStorage.getItem('userdata');
          this.userData = JSON.parse(data);
          if(data == null){
            this.$message('请先登录！');
            this.$router.push('/');
          }
          if(this.userData.level == 0){
            that.navList = [
              {
                id:5,
                label: '系统管理',
                children: [{
                  id:'5-4',
                  label: '开通机构和账号',
                  url:'/open'
                }]
              }
            ]
          } else {
          };
          if(this.userData.type == 2){//模拟卷
            that.navList = [
              {
                id:1,
                label: '考试管理',
                children: [{
                  id:'1-1',
                  label: '考试类型管理',
                  url:'/exam'
                },{
                  id:'1-2',
                  label: '考试列表',
                  url:'/examList'
                }]
              }, 
              {
                id:3,
                label: '学员管理',
                url:'/parent'
              },
              {
                id:6,
                label: '老师管理',
                url:'/teacher'
              },
              {
                id:8,
                label: '成绩管理',
                url:'/score'
              },
              {
                id:5,
                label: '系统管理',
                children: [{
                  id:'5-1',
                  label: '后台帐号管理',
                  url:'/admin'
                },{
                  id:'5-2',
                  label: '角色管理',
                  url:'/power'
                },{
                  id:'5-3',
                  label: '账户信息',
                  url:'/account'
                }]
              },
              {
                id:4,
                label: '会员管理',
                url:'/vipList'
              },
              {
                id:7,
                label: '营销管理',
                children: [{
                  id:'7-1',
                  label: 'banner',
                  url:'/market'
                },
                {
                  id:'7-2',
                  label: '意见反馈',
                  url:'/feedback'
                }
              ]
              },
            ]
          }
        }
      }
  }
</script>
<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/comment/nav.vue